import { NAME_PATTERN } from '../constants';
import { Component, ChangeDetectorRef, OnInit, AfterViewInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { PatientRegistrationData } from '../../../@core/interfaces/patient-services/patient-registration';
import { NbDateService, NbDialogService, NbThemeService } from '@nebular/theme';
import { Subject } from 'rxjs';
import { distinctUntilChanged, filter, take, takeUntil } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { RolesData } from '../../../@core/interfaces/common/roles';
import { UserData } from '../../../@core/interfaces/common/users';
import { DateService } from '../../../@theme/components/common/service/date.service';
import { InitUserService } from '../../../@theme/services/init-user.service';
import { PatientAppointmentData } from '../../../@core/interfaces/patient-services/patient-appointment';
import { NUMBERS_PATTERN } from '../constants';
import { TenantData,Tenant } from '../../../@core/interfaces/masters/tenant';
import { NB_AUTH_OPTIONS, NbAuthResult, NbAuthService, NbAuthSocialLink, } from '@nebular/auth';
import { Location } from '@angular/common';
import { ToastrAppSrvcService } from '../../../_services/toastr-app-srvc.service';
import { imageatch_detData } from '../../../@core/interfaces/masters/imageatch_det';
import { HttpClient } from '@angular/common/http';
import * as gender from './../../../data/gender.json';
import * as title from './../../../data/title.json';
import { INgxSelectOption } from 'ngx-select-ex';

@Component({
  selector: 'app-care-login',
  templateUrl: './care-login.component.html',
  styleUrls: ['./care-login.component.scss']
})
export class CareLoginComponent implements OnInit {

  userType: string = ''; // 'doctor' or 'patient' or 'traveller'
  previousUserType: string = '';
  isTraveller: boolean = false;
  loginUserType: string = ''; // 'doctor' or 'foreign-worker' or 'traveller' or 'employer'

  // Doctor Login Form
  doctorId: string = '';
  doctorPassword: string = '';

  // Patient Login Form
  patientPhone: string = '';
  usePassportNumber: boolean = false;



  resetForm: FormGroup;
  bookingPlatFormApp: FormGroup;
  otpForm: FormGroup;
  loginForm: FormGroup;
  genderList: string[] = (gender as any).default;
  titleList: any = (title as any).default;

  mobileMinlength: number = 10;
  mobileMaxlength: number = 10;
  isLogin: number = 0;
  signUp: boolean = false;
  patientDetails: Array<any> = [];
  patientLists: Array<any> = [];
  userList: Array<any> = [];
  isPassport = false;
  submitted: boolean;
  valueType: string ;
  tenatId: string ;
  branchId: string ;
  cusId: string ;
  get fullName() { return this.loginForm.get('fullName'); }
  get password() { return this.loginForm.get('password'); }
  maxDobDate: Date;
  @ViewChild("digit1") d1Element: ElementRef;
  @ViewChild("digit2") d2Element: ElementRef;
  @ViewChild("digit3") d3Element: ElementRef;
  @ViewChild("digit4") d4Element: ElementRef;
  @ViewChild("digit5") d5Element: ElementRef;
  @ViewChild("digit6") d6Element: ElementRef;
  @ViewChild("verifybtn") verifyBtnElement: ElementRef;
  protected readonly unsubscribe$ = new Subject<void>();

  countryCodeDropDownLists: Array<any> = [];
  messages: any[];
  errors: any[];
  userAlreadyExists: boolean;
  user: any;
  loginResult: any;
  data: Array<any> = [];
  loginUserAuthorized: boolean = false;
  accessToken: string;
  loginData: any;
  OTPid: any;
  phoneNumber: any;
  smscontent: string;
  emailcontent: string;
  sendthroughsms: boolean;
  templateData: any;
  isOtpDia: boolean;
  mobileVerifyPopUp: boolean = false;
  isSuccess: boolean = false;
  isFailure: boolean = false;
  isSubmitted:boolean=false;
  customerTenantLogo:string = "../../../../assets/images/ezovion-logo.png";

  constructor(
    private toaster: ToastrAppSrvcService, private patAptSrv: PatientAppointmentData,
    protected cd: ChangeDetectorRef, private iatchSrvc: imageatch_detData,
    protected tenantSrvc: TenantData,
    protected service: NbAuthService,
    @Inject(NB_AUTH_OPTIONS) protected options = {},
    protected router: Router,
    private route: ActivatedRoute, private fb: FormBuilder,protected http:HttpClient,
    private patSrvc: PatientRegistrationData, protected rolesService: RolesData, protected userService: UserData, public DatService: DateService, protected initUserService: InitUserService, private getDrAppointmentService: PatientAppointmentData, protected dateService: NbDateService<Date>,) {

    const mobileNumberValidators = [Validators.pattern(NUMBERS_PATTERN),];
    this.resetForm = this.fb.group({
      password: this.fb.control('', [Validators.required, Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\\d$@$!%*?&]{7,}$')]),
      confirmPassword: this.fb.control('', [Validators.required, Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\\d$@$!%*?&]{7,}$')])
    })
    this.bookingPlatFormApp = this.fb.group({
      mobile: this.fb.control(null, [Validators.required]),
      firstName: this.fb.control(null, [Validators.required, Validators.pattern(NAME_PATTERN)]),
      lastName: this.fb.control(null, [Validators.pattern(NAME_PATTERN)]),
      dob: this.fb.control(null, [Validators.required]),
      gender: this.fb.control(null, [Validators.required]),
      title: this.fb.control(null, [Validators.required]),
      pass: this.fb.control(null, [Validators.required, Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\\d$@$!%*?&]{7,}$')]),
      confirmPass: this.fb.control(null, [Validators.required, Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\\d$@$!%*?&]{7,}$')]),
      mobileCountryCode: this.fb.control(null, [Validators.required]),
      email: this.fb.control(null, [Validators.email, Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)]),
      tourPassportNumber: this.fb.control(null, [Validators.pattern('^[A-Za-z0-9]+$'), Validators.maxLength(20)]),
    });

    this.loginForm = this.fb.group({
      fullName: this.fb.control('', [...mobileNumberValidators]),
      password: this.fb.control('',),
      rememberMe: this.fb.control(''),
      tenantId: this.fb.control(''),
      branchId: this.fb.control(''),
      mobileCountryCode: this.fb.control('', [Validators.required])
    });
    
    this.route.paramMap.subscribe(p => { this.valueType = p.get('type'); });

    if (!!this.valueType && this.valueType != '') {
      localStorage.setItem('PatloginUserType', this.valueType);
    };

    const portalSubType = this.route.snapshot.data['portalSubType'];
    this.isTraveller = ['traveller', 'employer', 'doctor', 'foreign-worker'].includes(portalSubType);
    if (this.isTraveller) {
      this.loginForm.reset();
      this.loginResult=null;
      this.messages = [];
      this.errors = [];
    if(this.isTraveller) this.loginUserType = portalSubType;
    }
    
    var regID = localStorage?.getItem("regID");
    if (regID != null) {
      // this.router.navigateByUrl("pages/patient-portal/landing/"+regID);
    }
    this.otpForm = this.fb.group({
      digit1: this.fb.control('', [Validators.pattern('^[0-9-]+$'), Validators.maxLength(1), Validators.minLength(1)]),
      digit2: this.fb.control(''),
      digit3: this.fb.control(''),
      digit4: this.fb.control(''),
      digit5: this.fb.control(''),
      digit6: this.fb.control(''),
    });
    this.otpForm.get("digit1").valueChanges
      .pipe(filter((value: string) => value.length === 1))
      .subscribe(() => this.d2Element.nativeElement.focus());
    this.otpForm.get("digit2").valueChanges
      .pipe(filter((value: string) => value.length === 1))
      .subscribe(() => this.d3Element.nativeElement.focus());
    this.otpForm.get("digit3").valueChanges
      .pipe(filter((value: string) => value.length === 1))
      .subscribe(() => this.d4Element.nativeElement.focus());
    this.otpForm.get("digit4").valueChanges
      .pipe(filter((value: string) => value.length === 1))
      .subscribe(() => this.d5Element.nativeElement.focus());
    this.otpForm.get("digit5").valueChanges
      .pipe(filter((value: string) => value.length === 1))
      .subscribe(() => this.d6Element.nativeElement.focus());
    this.otpForm.get("digit6").valueChanges
      .pipe(filter((value: string) => value.length === 1))
      .subscribe(() => this.verifyBtnElement.nativeElement.focus());

    this.maxDobDate = this.dateService.addDay(this.dateService.today(), 0);
  }

  ngOnInit(): void {
    localStorage.clear();
    // Explicit, not just implied by clear() - this is the legacy Care-Sphere login,
    // never the WellSpring App, regardless of what a prior tab session left behind.
    localStorage.setItem('WellSpringAppFlag', 'false');
    this.tenantCheck();
    if (this.isTraveller) {
      this.userType = 'patient';
      localStorage.setItem('portalSubType', this.loginUserType);
    }
  }

  selectUserType(type: string): void {
    this.loginForm.reset();
     this.loginResult=null;
    this.messages = [];
    this.errors = [];
    this.userType = type;
  }

  goBack(): void {
    this.userType = '';
    this.resetForms();
  }

  doctorLogin(): void {
    if (this.doctorId && this.doctorPassword) {
      // Add your doctor login logic here
      localStorage.setItem('userType', 'doctor');
      localStorage.setItem('doctorId', this.doctorId);

      // Navigate to care-sphere dashboard
      setTimeout(() => {
        this.router.navigate(['/pages/care-sphere/patient-dashboard']);
      }, 1000);
    }
  }

  patientLogin(): void {
    if (this.patientPhone) {
      console.log('Patient Login:', { phone: this.patientPhone, usePassport: this.usePassportNumber });
      // Add your patient login logic here
      localStorage.setItem('userType', 'patient');
      localStorage.setItem('patientPhone', this.patientPhone);

      // Navigate to care-sphere dashboard
      setTimeout(() => {
        this.router.navigate(['/pages/care-sphere/patient-dashboard']);
      }, 1000);
    }
  }

  togglePassportNumber(): void {
    this.usePassportNumber = !this.usePassportNumber;
  }

  resetForms(): void {
    this.doctorId = '';
    this.doctorPassword = '';
    this.patientPhone = '';
    this.usePassportNumber = false;
  }

  nphiesDiscoverIdentitySearch(val) {
    const identity_num = 'PassportNumber';
    const identity_ty = val;

    if (!identity_num || !identity_ty) {
      return;
    }

    const URL = `NphiesBeneficiaryDiscoveryInsurance/${this.tenatId}/${this.branchId}/GetNphiesBeneficiaryDiscoveryInsurances/PassportNumber/${identity_ty}`


    this.patSrvc.getById(`${URL}`).pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: (res: any) => {
          if (res) {

            localStorage.setItem('policyData', JSON.stringify(res))

          }
        },
        error: (err) => {

        },
      });
  }
  requiredFlag: boolean = false
  setPassportRequired(isPolicyValid: boolean) {
    const ctrl = this.bookingPlatFormApp.get('tourPassportNumber');
    if (!ctrl) return;

    const currentValidator = ctrl.validator;

    if (isPolicyValid) {
      ctrl.setValidators([currentValidator, Validators.required]);
      this.requiredFlag = true;
    } else {
      ctrl.setValidators(currentValidator);
      this.requiredFlag = false;
    }

    ctrl.updateValueAndValidity();
  }



  loginCreate(): void {
    this.submitted = true;
    this.loginForm.controls["tenantId"].setValue(this.tenatId);
    this.loginForm.controls["branchId"].setValue(this.branchId);
    if(this.loginUserType === 'doctor') this.userType = 'doctor';
    if (this.userType !== 'patient') { this.loginForm.controls["mobileCountryCode"].setValue(null); } else { this.loginForm.controls["mobileCountryCode"].setValue(this.countryId); }
    this.user = this.loginForm.value;
    this.messages = [];
    this.submitted = true;
    const auth = {
      "fullName": "9500672785",
      "password": "Ezovion@1",
      "rememberMe": "",
      "tenantId": "6b5d5bf1-e369-4b5d-e9b3-08dacd6f38e4",
      "branchId": "4e54f59e-226b-42a3-8ef2-cda3ac8fc727"
    }

    this.service.authenticate("email", this.user).subscribe((result: NbAuthResult) => {
      this.submitted = false;
      this.loginResult = result;
      if (result.isSuccess()) {
        this.messages = result.getMessages();
        this.initUserService.initCurrentUser().pipe(take(1))
          .subscribe(() => {

            // Now localStorage is guaranteed set
            this.userAlreadyExists = false;

            localStorage.setItem('InsuranceFlag', 'true');
            localStorage.setItem('PatloginUserType', this.valueType);
            localStorage.removeItem('customerTenantLogo');
	     localStorage.removeItem('customerName');
            localStorage.setItem('customerTenantLogo',this.customerTenantLogo);
            localStorage.setItem('customerName', this.customerName);
            //localStorage.setItem("loginuser", "insuranceLogin");
            // localStorage.setItem('PatientDynamicTenant', this.tenatId);
            // localStorage.setItem('PatientDynamicBranch', this.branchId);

            if (this.userType === 'doctor' || this.loginUserType === 'doctor' ) {
              localStorage.setItem('userType', 'doctor');
              this.doctorLoginCreate();
            } else { 
              localStorage.setItem('userType', 'patient');
              this.patientLoginCreate(); }

          });
      }
      else {

      this.errors=[];
        if (result.getResponse().status == 403) {
          this.errors.push("Your account has been disabled, Please see your administrator");
        }
        else {
          this.errors.push("Incorrect credentials. Try again.");
          if(this.loginUserType){
            return this.router.navigate([`/auth/care-sphere/${this.valueType}/${this.loginUserType}`]);
          }
          else
          return this.router.navigate([`/auth/care-sphere/${this.valueType}`]);
        }


      }


      this.cd.detectChanges();
    });
  }

  decide(eve) {
    if (this.userType === 'patient') { this.numberOnly(eve) } else { this.saverange(eve) }
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    this.checkIsExists(event);
    return true;

  }

  lastFourDigits:any;
  notUser:boolean=false;
  get apiUrl(): string { return environment.apiUrl;}

  verifyMobileIsexist() {
    this.errors = [];
      let data={
        "PatientMobile":this.loginForm.get('fullName').value,
        "countryId":this.loginForm.get('mobileCountryCode')?.value
      }
      this.lastFourDigits=this.loginForm.get('fullName').value?.toString().slice(-4);
      this.getDrAppointmentService.searchList(`bookingPlatform/checkIsPatientExists`, data).pipe(takeUntil(this.unsubscribe$)).subscribe(returnData => {
        if(!!returnData?.user){  
          this.notUser=false;
          this.phoneNumber = this.loginForm.get('fullName').value;
          if(!!this.phoneNumber && this.phoneNumber!=undefined){
        
          this.userService.getBranchList(`users/mobile/${this.phoneNumber}/${this.tenatId}`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
            if(!!data){
              this.getotpsms();
            }
          }, (error) => {

          }, () => {
          
          });
          }
        }else{
          this.notUser=true;

        }

      })
        

  }

  getotpsms(){
    let data = {
      "headers": {
        "Accept": "application/vnd.ezovion.hateoas+json",
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    }
    this.rolesService.create(`${this.apiUrl}/patientportalnewuser/${this.tenatId}/sendotp/${this.phoneNumber}`,data).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.OTPid=data;
    }, (error) => {
    }, () => {
      this.mobileVerifyPopUp = true;
    });
  }

  verifyPass(event){
    
    event.target.disabled = true;
    if(this.resetForm.valid && (this.resetForm.get('password').value == this.resetForm.get('confirmPassword').value)){
      const det = {
        Password: this.resetForm.get('password')?.value,
        ConfirmPassword: this.resetForm.get('password')?.value,
        MobileNumber: this.phoneNumber
      }
      this.http.post(environment.apiUrl+'/auth/updatePassword',det).pipe(takeUntil(this.unsubscribe$)).subscribe(()=>{
        this.resetForm.reset();
        event.target.disabled = false;
        this.toaster.ForSuccess('Password reset successful. Please log in with your new password.');
        this.isSuccess = true;
        this.onClickBackToLogin();
      });

    }else{
      event.target.disabled = false;
    }
  }

  checkIsExists(event) {


    if (event.target.value.length >= this.mobileMinlength && event.target.value.length <= this.mobileMaxlength) {
      let data = {
        "PatientMobile": event.target.value,
        "countryId": this.bookingPlatFormApp.get('mobileCountryCode')?.value
      }
      event.target.disabled = true;
      this.getDrAppointmentService.searchList(`bookingPlatform/checkIsPatientExists`, data).pipe(takeUntil(this.unsubscribe$)).subscribe(returnData => {

        this.patientLists = [];
        this.userList = [];
        const formControlsToUpdate = ['firstName', 'lastName', 'dob', 'gender', 'title'];
        formControlsToUpdate.forEach(key => {
          this.bookingPlatFormApp.controls[key]?.reset();
          this.bookingPlatFormApp.controls[key]?.enable();
        });

        // Check if the patient alone exists
        if (returnData.patient.length !== 0 && returnData.user == null) {
          this.patientDetails = returnData?.patient;
          this.bookingPlatFormApp.get('firstName')?.setValue(this.patientDetails[0]?.firstname);
          this.bookingPlatFormApp.get('firstName')?.disable();
          this.bookingPlatFormApp.get('lastName')?.setValue(this.patientDetails[0]?.lastname);
          this.bookingPlatFormApp.get('lastName')?.disable();
          this.bookingPlatFormApp.get('email')?.setValue(this.patientDetails[0]?.email);
          this.bookingPlatFormApp.get('email')?.disable();
          const formControlsToUpdate = ['gender', 'title'];
          if (this.patientDetails[0]?.dobFlag == 'N') {
            this.bookingPlatFormApp.get('dob')?.setValue(this.patientDetails[0]?.ageResult);
          }
          else {
            this.bookingPlatFormApp.get('dob')?.setValue(this.patientDetails[0]?.dob);
          }
          this.bookingPlatFormApp.get('dob')?.disable();
          formControlsToUpdate.forEach(key => {
            this.bookingPlatFormApp.controls[key]?.setValue(this.patientDetails[0]?.[key]);
            this.bookingPlatFormApp.controls[key]?.disable();
          });

          this.userAlreadyExists = false;
        }
        // Check if both patient and user exist
        else if (!!returnData.patient && returnData.user != null) {
          if (this.isLogin != 0) {
            this.isLogin = 0;
            this.userAlreadyExists = true;
          }
          // this.openLoginPopup = true;
          this.signUp = false;
          this.loginForm.get('fullName').setValue(event.target.value);
          this.patientLists = returnData.patient;
          this.userList = returnData.user;
        }
        //when neither patient nor user exist
        else {
          this.userAlreadyExists = false;
          // this.openLoginPopup = false;
          // this.customer = false;
          this.bookingPlatFormApp.get('firstName')?.enable();
          this.bookingPlatFormApp.get('lastName')?.enable();
          this.bookingPlatFormApp.get('dob')?.enable();
          //  this.bookingPlatFormApp.get('gender')?.enable();

          // if (this.isLogin == 0) {
          //   this.toaster.ForDanger('No account found with this mobile number. Please sign up to continue.');
          // }
        }
      }, (error) => {
        event.target.disabled = false;
      }, () => {
        event.target.disabled = false;
      });
    }

  }


  onVerify() {

    let otp = "";
    otp += this.otpForm.get('digit1').value;
    otp += this.otpForm.get('digit2').value;
    otp += this.otpForm.get('digit3').value;
    otp += this.otpForm.get('digit4').value;
    otp += this.otpForm.get('digit5').value;
    otp += this.otpForm.get('digit6').value;
    if (otp != "") {
      if (otp == this.OTPid) {
        this.isSuccess = true;
        this.isFailure = false;
        this.userType = 'resetPassword';
        this.mobileVerifyPopUp = false;
      }
      else {
        this.isFailure = true;
        this.isSuccess = false;
      }
    }
  }
  countryId: string;

  customerName:string;

  tenantCheck(){
    const pay:any={
    "tenantId": this.valueType,
    "tenantEmailId": ""
  }
    this.tenantSrvc.getTenantData(`${environment.apiUrl}/auth/validtenant`, pay).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      if(!!data?.token?.id) {
      this.tenatId = data?.token?.id;
      localStorage.setItem('tenantId', this.tenatId); }
      localStorage.setItem('tenantType', data?.token?.tenantType); 
    },()=>{
      this.router.navigate([`auth/care-sphere/${this.valueType}`]);
    },async ()=>{
      await this.branchCheck();
    });
 
}
countId:string;
  branchCheck() {

    this.rolesService.list(`tenants/${this.tenatId}/tenantbranch`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      const det = data?.value?.sort((a, b) => new Date(b?.createdDate)?.getTime() - new Date(a?.createdDate)?.getTime())[0];
      this.branchId = det?.id;
      this.customerName = det?.branchName;
      localStorage.setItem('customerName', this.customerName);
      localStorage.setItem('countryCode', det?.mobileCountryCode);
      localStorage.setItem('branchId', this.branchId);
      const branchCode = det?.mobileCountryCode;
      this.countryId = det?.country;
      this.loginForm.get('mobileCountryCode').setValue(det?.country)
      this.loadCountryMasterForLogin(branchCode);
      this.getTenantBanner();
    }, (err) => {
      this.router.navigate([`auth/care-sphere/${this.valueType}`]);
    })

  }

  loadCountryMasterForLogin(cc): void {
    this.patAptSrv.list(`countries/getCountryMasterAnonymous`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.countryCodeDropDownLists = data?.details?.filter(x => x?.countryCode != null);

    }, (error) => {
      if (error.status == 401) {
        this.router.navigateByUrl(`/auth/care-sphere/${this.valueType}`);
      }
    }, () => {
      const countryCode = this.countryCodeDropDownLists?.filter(x => x?.countryCode == cc);
      if (countryCode?.length > 0) {
        this.mobileMinlength = countryCode[0]?.minMobileNumberLength;
        this.mobileMaxlength = countryCode[0]?.maxMobileNumberLength;
        this.loginForm.get('mobileCountryCode')?.setValue(countryCode[0]?.id);
        localStorage.setItem('selectedCountryId', countryCode[0]?.id);
        this.countId = countryCode[0]?.id;
        this.bookingPlatFormApp.get('mobileCountryCode')?.setValue(countryCode[0]?.id);
      }
    });
  }
  userData: Array<any> = [];
  saverange(x) {
    if (x.target.value.length <= this.mobileMaxlength && x.target.value.length >= this.mobileMinlength) {
      var mobileNo = x.target.value;
      this.userService.getBranchList(`users/mobile/${mobileNo}/${this.tenatId}`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
        this.userData = data;
        if (this.userData.length == 1) {
          this.loginForm.controls["branchId"].setValue(this.userData[0].id);
          localStorage.setItem('LoginCountryCode', this.userData[0]?.mobileCountryCode);

        }

      }, (error) => {
        this.router.navigateByUrl(`/auth/care-sphere/${this.valueType}`);
      }, () => {

      });
    }
  }
  patientLoginCreate(): void {

    var searchData = {
      "searchWord": this.user.fullName,
      "fromDate": null,
      "toDate": null,
      "skip": 0,
      "take": 100
    };
    this.patSrvc.searchList("patientregistrationmst/" + this.tenatId + '/' + this.branchId + '/search', searchData).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      const selected = data.find(x => x.country === this.loginForm.get('mobileCountryCode')?.value) || data[0];
      if (!!this.valueType) {
        this.nphiesDiscoverIdentitySearch(selected?.tourPassportNumber);
        // this.setPassportRequired(true);
        localStorage.setItem('PatloginUserType', this.valueType);
      }


      localStorage.setItem("regID", selected.id);
      localStorage.setItem("patientMobNo", this.user.fullName);
      localStorage.setItem("patientName", selected.firstname);
      localStorage.setItem("patientCountryCode", selected.country);
      localStorage.setItem("age", selected.age?.toString());
      localStorage.setItem('gender',selected?.gender);
      localStorage.setItem('dob',selected?.dob);
      localStorage.setItem('address1',!!selected?.address1?selected?.address1:'');
      localStorage.setItem('address2',!!selected?.address2?selected?.address2:'');
      localStorage.setItem('doorno',!!selected?.doorno?selected?.doorno:'');
      localStorage.setItem("lastname", !!selected.lastname?selected.lastname:'');
      localStorage.setItem("middlename", !!selected.middlename?selected.middlename:'');

      if (data[0]?.email) {
        localStorage.setItem('patientEmail', data[0]?.email);
      }
      this.submitted = false;
      // localStorage.setItem('countryCode', this.cc);
      return this.router.navigate(['/pages/care-sphere/patient-dashboard'],{ queryParams: { fromLogin: true } });

    });

  }

  doctorLoginCreate(): void {

    this.iatchSrvc.getById(`${environment.apiUrl}/physicians/${localStorage.getItem("tenantId")}/${localStorage.getItem("branchId")}/${localStorage.getItem("physicianId")}/GetPhyscianById`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {

      const deptName = encodeURIComponent(data?.department?.name);
      localStorage.setItem("deptName", deptName);
      localStorage.setItem("departmentId", data?.department?.id);
      localStorage.setItem("restrictedPatientAppointments", data?.restrictedPatientAppointments);
      localStorage.setItem("restrictedViewPatientSurgery", String(data?.restrictedViewPatientSurgery ?? false));
      // let routingUrl=localStorage.getItem("landingPageUrl")+localStorage.getItem("physicianId")+"/"+deptName;
      let routingUrl = "/pages/care-sphere/doctor-dashboard";
      localStorage.setItem("academicRank", data?.academicRank);

      return this.router.navigate([routingUrl]);
    }, (error) => {

    }, () => {
    });
  }

  onClickforgotPassword(){
    this.previousUserType = this.userType;
    this.userType = 'forgotPassword';
  }

  onClickBackToLogin(){
    this.userType = this.previousUserType;
    this.isSuccess = true;
    this.loginForm.reset();
  }

  newPatient(){
    this.signUp = true;
    this.isSubmitted=false;
    this.countryCodeDropDownLists;
    // setTimeout(() => {this.loginForm.controls["mobileCountryCode"].setValue(this.countId);},1000);
    // this.onCountryCodeChange(this.countId,'Mobile');
  }
  onClickClose(){
    this.errors = [];
    this.signUp = false;
    this.bookingPlatFormApp.reset();
    this.bookingPlatFormApp.get('mobileCountryCode')?.setValue(this.countId);
    // this.invalidbookingPlatFormAppForm = false;
  }
  get fval() { return this.bookingPlatFormApp.controls; }
  onCountryCodeChange(code , type) {
    if(type=='Mobile'){
      this.mobileMinlength = code[0]?.data?.minMobileNumberLength ;
      this.mobileMaxlength = code[0]?.data?.maxMobileNumberLength ;
      this.bookingPlatFormApp.get('mobile').setValidators([Validators.minLength(this.mobileMinlength) , Validators.maxLength(this.mobileMaxlength)]);
      this.bookingPlatFormApp.get('mobile').updateValueAndValidity();
    }
  }

      focustoOpenSelect($event){ 
          $event.optionsOpen()
        }
        tabToClose($event){
          $event.optionsClose()
        }
        onTitleChange(event: INgxSelectOption[]) {
          if(event){
                    if (event[0]?.data?.value == "1" || event[0]?.data?.value == "5") {
            this.bookingPlatFormApp.controls['gender'].setValue("Male");
          }
          else if (event[0]?.data?.value == "2" || event[0]?.data?.value == "3" || event[0]?.data.value == "4") {
            this.bookingPlatFormApp.controls['gender'].setValue("Female");
          }
          this.bookingPlatFormApp.get('gender').disable();  
        }
      }

  userName:string='';
  userMobileNumber:string='';
  selectedCC:string='';
  patientEmail:string;
            saveAppBooking(fromLogin?){
              this.isSubmitted=true;
              if(this.bookingPlatFormApp.valid && this.bookingPlatFormApp?.get('pass')?.value === this.bookingPlatFormApp?.get('confirmPass')?.value || !!fromLogin){
                // this.isSubmitted=true;
                let newData=new Date( this.bookingPlatFormApp.get('dob').value);
                const today = new Date();
            
                var Difference_In_Time = Math.abs(Date.now() - newData.getTime());
                var Difference_In_Days = Math.ceil(Difference_In_Time / (1000 * 3600 * 24));
                var ageValue = Difference_In_Days / 365.25;
                const year = (Math.round(ageValue));
                this.userName = this.bookingPlatFormApp.get('firstName').value;
                this.userMobileNumber = this.bookingPlatFormApp.get('mobile').value
                const fullname=this.bookingPlatFormApp.get('firstName').value+(this.bookingPlatFormApp.get('lastName').value ?''+this.bookingPlatFormApp.get('lastName').value:'');
                this.selectedCC = this.countryCodeDropDownLists.find(c => c.id === this.bookingPlatFormApp.get('mobileCountryCode')?.value)?.countryCode
                let requestData ={
                    branchId: this.branchId,
                    email: this.bookingPlatFormApp.get('email').value,
                    fName:  this.bookingPlatFormApp.get('firstName').value,
                    lName: null,
                    mobileNum: this.bookingPlatFormApp.get('mobile').value,
                    tenantId: this.tenatId,
                    fullName: fullname,
                    userFlag: "Patient",
                    title: this.bookingPlatFormApp.get('title').value,
                    gender: this.bookingPlatFormApp.get('gender').value,
                    age: year,
                    loginUserType: "patientlogin",
                    password: this.bookingPlatFormApp.get('pass').value,
                    confirmPassword: this.bookingPlatFormApp.get('confirmPass').value,
                    CountryId:this.bookingPlatFormApp.get('mobileCountryCode')?.value,
                    mobileCountryCode: this.selectedCC,
                    dob:this.bookingPlatFormApp.get('dob').value
                  }
      
                  if( this.patientDetails && this.patientDetails.length >0 ){
                    requestData ={
                      ...requestData,
                      ...{
                      dobFlag: this.patientDetails[0]?.dobFlag,
                      ageResult: this.patientDetails[0]?.ageResult}
                    }
      
                    if( this.patientDetails[0]?.dobFlag=='N' ){
                      requestData.dob=null;
                    }
                  }
      
                  this.http.post(environment.apiUrl+'/auth/virtual-patient-registration',requestData).subscribe((res: any) => {
                    // this.isAppointmentSaved=true; 
                    this.signUp=false;     
                  //   if(Object.keys(this.assesmentData).length > 0){ 
                  //     const asses= JSON.parse( this.assesmentData?.inputJson || '{}');
      
                  //     if( (asses?.ageCategory==1 && year>17 ) || (asses?.ageCategory==2 && (year<18 || year>64) ) || (asses?.ageCategory==3 && year<65) ){
                  //           this.assesPopUpForAgeMismatch=true;
                  //     }
                  //     else{
                  //   this.storeAssesmentData(res.regId);}
                  // }    
                  // this.isAssesment=false;
                  // this.isAppointmentBooking = false;
                  // this.page="signup";
                  this.loginForm.get('fullName').setValue(requestData.mobileNum);
                  this.loginForm.get('password').setValue(requestData.password);
                  this.loginForm.get('mobileCountryCode')?.setValue(requestData.CountryId);  
                  this.isSubmitted=false;
                  this.errors = [];
                    // setTimeout(()=>{ this.isAppointmentSaved=false;},4000)
                },(error)=>{
                  if(error.status==401){
                     this.router.navigateByUrl(`/auth/care-sphere/${this.valueType}`);
                  }
                },()=>{
                  if(requestData?.email) this.patientEmail = requestData?.email;
                  // this.checksmspossibility("confirmation")
                })
              }
      
           
             
            }
  get logoSrc(): string {
    return localStorage.getItem('tenantType') === 'secondopinion'
      ? '../../../../assets/images/caresphere/so-logo.svg'
      : this.customerTenantLogo;
  }

  get logoAlt(): string {
    return localStorage.getItem('tenantType') === 'secondopinion'
      ? 'Second Opinion Logo'
      : `${this.customerName} Logo`;
  }

  get welcomeHeading(): string {
    return localStorage.getItem('tenantType') === 'secondopinion'
      ? 'Welcome to Second Opinion'
      : `Welcome to ${this.customerName}`;
  }

  get travellerPortalSubType(): string {
    return localStorage.getItem('portalSubType') || '';
  }

  showPassword = false;

  togglePassword(): void {
    this.showPassword = !this.showPassword;
  }


getTenantBanner() {
  this.iatchSrvc.getById(`${environment.apiUrl}/ImageAtchDet/${this.tenatId}/${this.branchId}/loginBanner`).pipe(takeUntil(this.unsubscribe$)).subscribe(
  (data: any) => {
    if(data.length > 0){
    let tenantLogo = data.filter(e=>e.type=="logo");
    if(tenantLogo.length > 0){
      this.customerTenantLogo = 'data:image/jpeg;base64,' + tenantLogo[(tenantLogo.length-1)].image;
       localStorage.removeItem('customerTenantLogo');
      localStorage.setItem('customerTenantLogo',this.customerTenantLogo);
    }
      this.cd.detectChanges();
    } 
   }, (error) => {
      this.router.navigateByUrl(`/auth/care-sphere/${this.valueType}`);
   }, () => { });
  }
  

}
